module.exports = __webpack_public_path__ + "img/mjzh.1a71af88.jpg";